
import { TFFormResponse } from "../types"




export interface APIRequestModel<T> {
  data?: T;
  id?: string;
  token: string;
  isPublic: boolean;
}

export interface APIError {
  errorMessage: string;
  status: number;
  validationErrors: ValidationError[];
  data?: unknown;
}

export interface ValidationError {
  property: string;
  message: number;
  value: unknown;
}

export interface APIResponseModel<T> {
  success: boolean;
  message: string;
  data: T;
  errors: ValidationError[];
}

export interface UploadImageFileResponseModel {
  success: boolean;
  message: string;
  data?: string | null;
  errors: ValidationError[];
}

export interface FileApiResponse {
  fileName: string;
  fileUrl: string;
  path: string;
}

export interface FileResponseModel {
  files: FileApiResponse[];
  message: string;
}

export interface SignInResponse {
  username: string,
  name: string,
  email: string,
  phoneNumber: string,
  newPasswordRequired: boolean,
  session: string,
  accessToken: string,
  refreshToken: string,
  expiresIn: number,
  tokenType: string,
  isFirstLogin: boolean,
  assessed: boolean,
  result: TFFormResponse | string,
  // result: object,
}



export interface SessionFlashData {
  error: string;
}

export class HFWApiError extends Error {
  apiError: APIError;
  constructor(apiError: APIError) {
    super(apiError.errorMessage);
    this.apiError = apiError;
  }
}

export class HFWUnAuthorizedError extends Error {
  constructor(message: string) {
    super(message);
  }
}

export interface AppLoaderData<T> {
  data?: T | null;
  hasError: boolean;
  error?: HFWApiError | null;
  commonErrorMessage?: string | null;
}

// Generic loader type that forces the use of AppLoaderData
// export type AppLoader<T> = LoaderFunction & ((args: LoaderFunctionArgs) => Promise<AppLoaderData<T> | AppLoaderData<void>>);


export const getApiData = <T>(data: T): AppLoaderData<T> => {
  return {
    data,
    hasError: false,
    error: null,
    commonErrorMessage: null,
  };
}

export const getApiError = (error: HFWApiError): AppLoaderData<void> => {
  return {
    data: null,
    hasError: true,
    error,
    commonErrorMessage: null,
  };
}

export const getCommonErrorMessage = (message: string): AppLoaderData<void> => {
  return {
    data: null,
    hasError: true,
    error: null,
    commonErrorMessage: message,
  };
}

export type EndPointQueryParamsType = { [key: string]: string };
export type EndPointUrlOptions = { params: string[]; queryParams: EndPointQueryParamsType };
export type EndpointURLParamsType = (options?: EndPointUrlOptions | null) => string
export type EndpointMethodType = "GET" | "POST" | "DELETE" | "POST";


export interface APIEndpoint {
  url: EndpointURLParamsType;
  method: EndpointMethodType;
  key: string;
}

